import { WSPosterProps } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ISharedFileRequestResponse } from "@wingspanhq/shared-files/dist/lib/interfaces";
import { SharedFileRequestStatus } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import React from "react";

import { EmptyComponent } from "../../../../../../shared/components/EmptyComponent";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";
import { selectorSharedFileExtractedFields } from "../../../../selectors/selectorSharedFileExtractedFields";
import { ValidationProgress } from "../../components/ValidationProgress";
import { getSharedFileIsValidatingActive } from "../helpers/getSharedFileIsValidatingActive";

export const payeeSharedFileRenderCardDescription = (
  requirement: IRequirementResponse,
  sharedFile?: ISharedFileRequestResponse
) => {
  const signedDocumentDescriptions: Record<
    SharedFileRequestStatus,
    WSPosterProps
  > = {
    [SharedFileRequestStatus.PendingUpload]: {
      type: "documents",
      title: "File not uploaded",
      description: "Waiting for the contractor to upload a file."
    },
    [SharedFileRequestStatus.PendingSubmission]: {
      type: "documents",
      title: "Verification has failed.",
      description:
        "Contractor has a few attempts to try to upload the file again."
    },
    [SharedFileRequestStatus.Processing]: {
      type: "documents",
      title: "Verification in progress",
      description:
        "The contractor's file is being verified. This may take a few minutes."
    },
    [SharedFileRequestStatus.Failed]: {
      type: "documents",
      title: "File uploading has failed",
      description: "Something went wrong while uploading the file."
    },
    [SharedFileRequestStatus.Complete]: {
      type: "done",
      title: "Your file upload is complete",
      description: "You can download the file below."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: sharedFile?.status || SharedFileRequestStatus.PendingUpload,
    documentStatuses: signedDocumentDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document was uploaded",
      description:
        "The document was uploaded. The requirement now requires approval."
    },
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect the contractor’s eligibility for related engagements."
    },
    approvedStatus: null,
    customContent: getSharedFileIsValidatingActive(sharedFile) ? (
      <ValidationProgress jobs={sharedFile?.jobs} />
    ) : selectorSharedFileExtractedFields(sharedFile) ? (
      <EmptyComponent />
    ) : null
  });
};
